import { createAppRouter } from "@neu/libui";

import { pbmPortalPatientSubNavItems } from "#modules/patient/patientSubNavItems";
import {
	PbmPortalLayout,
	PbmPortalPatient,
	PbmPortalPatientDetail,
	pbmPortalPatientListConfig,
} from "#modules/pbm-portal";

export const pbmPortalRouter = createAppRouter({
	rootLayout: PbmPortalLayout,
	defaultRedirect: "/pbm-portal/patient",
	simpleRoutes: [],
	nestedModules: [
		{
			path: "/pbm-portal/patient",
			paramName: "patientID",
			entity: "patient",
			layout: PbmPortalPatient,
			detail: PbmPortalPatientDetail,
			subRoutes: pbmPortalPatientSubNavItems,
			componentProps: {
				showAddButton: false,
			},
			...pbmPortalPatientListConfig,
		},
	],
});

declare module "@tanstack/react-router" {
	interface Register {
		router: typeof pbmPortalRouter;
	}
}
